const words = [
    '与',
    '个',
    '了',
    '人们',
    '人們',
    '他们',
    '他們',
    '你们',
    '你們',
    '個',
    '及',
    '和',
    '她们',
    '她們',
    '妳們',
    '就',
    '我们',
    '我們',
    '或',
    '是',
    '是否',
    '沒有',
    '的',
    '着',
    '种',
    '種',
    '而',
    '自己',
    '與',
    '著',
    '都',
];
export default words;
//# sourceMappingURL=chinese.js.map